import React from "react";
import { Tag } from "antd";

const StatusTag = ({ status }) => {
  // Define your status colors
  const statusConfig = {
    1: { text: "Pending", color: "gold" },
    2: { text: "In Progress", color: "blue" },
    3: { text: "Completed", color: "green" },
    4: { text: "Stopped", color: "red" },
    5: { text: "Expired", color: "orange" },
  };

  const { text, color } = statusConfig[status] || {
    text: "Unknown",
    color: "default",
  };

  return <Tag color={color}>{text}</Tag>;
};

export default StatusTag;
